<mat-card>
  <h1>Urla Version {{version}}</h1>
  <p>
    Options:
    <span *ngIf="sqlEscaped">SQL Escaped</span>
  </p>
  <pre><code>{{configJson}}</code></pre>
</mat-card>
